import { render, staticRenderFns } from "./mainController.vue?vue&type=template&id=a14d6512&scoped=true"
import script from "./mainController.vue?vue&type=script&lang=js"
export * from "./mainController.vue?vue&type=script&lang=js"
import style0 from "./mainController.vue?vue&type=style&index=0&id=a14d6512&prod&lang=scss"
import style1 from "./mainController.vue?vue&type=style&index=1&id=a14d6512&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a14d6512",
  null
  
)

export default component.exports